import {useNavigate} from "react-router-dom";
import packageJson from '../../package.json';
import React from "react";

//Стили
import "./style/greeting.css";
import "./style/palette.css";
import "./style/common.css";

//Страница 404 - не найдена
export default function NotFoundPage() {
    const navigate = useNavigate();

    const handleGoHomeClick = () => {
        navigate("/");
    };

    return (
        <div className={"d-flex flex-column align-items-center"}>
            <div id={"greeting"}>
                <div id={"greeting-block"} className={"mx-2"}>
                    <div className={"greeting-img-block"}>
                        <img src={"../icons/logo-idgos.png"} alt={"!#"} className={"logo-idgos"}/>
                    </div>
                    <div className={"greeting-text-block"}>
                        <h1 className={"greeting-title text-center"}>
                            404
                        </h1>
                        <p className={'greeting-subtitle text-center fw-bold color_red'}>
                            {'Страница не найдена'}
                        </p>
                        <p className={"greeting-subtitle text-center mb-1"}>
                            Запрашиваемая страница не существует
                        </p>
                        <p className={"greeting-subtitle text-center"}>
                            или была удалена
                        </p>
                    </div>

                    <div className={"d-flex flex-column align-items-center mt-3"}>
                        <button onClick={handleGoHomeClick}
                                className={"border-0 greeting-continue greeting-continue-false"}>
                            На главную
                        </button>
                    </div>
                </div>
            </div>
            <div className={"app-version text-end width90"}>версия {packageJson.version}</div>
        </div>
    );
};
